import React from "react";
import { Users, Clock, Timer, DollarSign, Percent, Gift, SlidersHorizontal, Receipt, Wallet } from "lucide-react";
import { money2 } from "./payrollHelpers";

function Card({ icon: Icon, label, value, accent = "text-slate-900", testid }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-3" data-testid={testid}>
      <div className="flex items-center gap-1.5 text-[10.5px] font-bold uppercase tracking-wider text-slate-400">
        <Icon className="h-3.5 w-3.5" /> {label}
      </div>
      <div className={`text-[18px] font-bold mt-1 ${accent}`}>{value}</div>
    </div>
  );
}

export default function PayrollSummaryCards({ rows, adjustmentsTotal, taxTotals }) {
  const totalRegHours = rows.reduce((s, r) => s + r.regularHours, 0);
  const totalOtHours = rows.reduce((s, r) => s + r.otHours, 0);
  const systemGross = rows.reduce((s, r) => s + r.total, 0);
  const totalGross = systemGross + (adjustmentsTotal || 0);
  const totalCommission = rows.reduce((s, r) => s + r.commission, 0);
  const totalBonus = rows.reduce((s, r) => s + r.bonus, 0);
  const totalTaxes = taxTotals?.currentDeductions || 0;
  const netPay = totalGross - totalTaxes;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="payroll-summary-cards">
      <Card icon={Users} label="Employees" value={rows.length} testid="payroll-card-employees" />
      <Card icon={Clock} label="Regular Hours" value={totalRegHours.toFixed(2)} testid="payroll-card-reg-hours" />
      <Card icon={Timer} label="OT Hours" value={totalOtHours.toFixed(2)} testid="payroll-card-ot-hours" />
      <Card icon={DollarSign} label="Gross Pay" value={money2(totalGross)} accent="text-emerald-700" testid="payroll-card-gross" />
      <Card icon={Percent} label="Commissions" value={money2(totalCommission)} testid="payroll-card-commission" />
      <Card icon={Gift} label="Bonuses" value={money2(totalBonus)} testid="payroll-card-bonus" />
      <Card icon={SlidersHorizontal} label="Adjustments" value={money2(adjustmentsTotal)} testid="payroll-card-adjustments" />
      <Card icon={Receipt} label="Taxes" value={money2(totalTaxes)} accent="text-rose-700" testid="payroll-card-taxes" />
      <Card icon={Wallet} label="Net Pay" value={money2(netPay)} accent="text-blue-700" testid="payroll-card-net" />
    </div>
  );
}
